function fadeOut(elm) {
  elm.classList.add('fade-out', 'no-delay');
}

function addCloseListener(notification) {
  const iconClose = notification.querySelector('.notification-close');
  if (iconClose) {
    iconClose.addEventListener('click', () => fadeOut(notification));
  }
}

export function initNotification(targetEl) {
  const target = targetEl || document;
  target.querySelectorAll('.notification-fixed').forEach(addCloseListener);
}
